import { APPKEY } from 'public/config'
const MAP_APPKEY = APPKEY['kye_map']
export const API_CODE_MAP = {
  FP_CODE: {
    url: 'address.regionInfo.getInfoByDistrictId',
    appkey: MAP_APPKEY || 55844,
    desc: '通过id。全链路获取其兄弟节点以及父级节点',
  },
  CHILDREN_CODE: {
    url: 'address.addressBgTerritory.getMultiLevelThinkList',
    appkey: MAP_APPKEY || 55844,
    desc: '查询字节点',
  },
  SEARCH_CODE: {
    url: 'address.regioninfo.getAreaAddress',
    // url: 'address.regioninfo.districtsByKeywords',
    appkey: MAP_APPKEY || 55844,
    desc: '模糊搜索',
  }
}

export const HOT_CITY_DATA = [
  {
    districtID: 'XZ1-06',
    districtName: '北京',
    shortName: '北京',
  },
  {
    districtID: 'XZ1-01',
    districtName: '上海',
    shortName: '上海',
  },
  {
    districtID: 'XZ2-042',
    districtName: '广州市',
    shortName: '广州',
  },
  {
    districtID: 'XZ2-229',
    districtName: '深圳市',
    shortName: '深圳',
  },
  {
    districtID: 'XZ2-253',
    districtName: '东莞市',
    shortName: '东莞',
  },
  {
    districtID: 'XZ2-316',
    districtName: '佛山市',
    shortName: '佛山',
  },
  {
    districtID: 'XZ2-311',
    districtName: '中山市',
    shortName: '中山',
  }
]

// 直辖市
export const MUNICIPALITY_MAP = {
  'XZ1-06': '北京',
  'XZ1-05': '天津',
  'XZ1-01': '上海',
  'XZ1-19': '重庆',
}

export const OTHER_CITIES_COUNTIES = '其他市县'



// WEBPACK FOOTER //
// ./src/public/components/kye-area/data/constant.js